import {
  ArchiveOutlined,
  DashboardOutlined,
  TaskAltOutlined,
  Settings,
} from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { Plus } from "react-bootstrap-icons";
export const items = [
  {
    title: "Dashboard",
    path: "/dashboard",
    approved: true,
    icon: (
      <SvgIcon fontSize="small">
        <DashboardOutlined />
      </SvgIcon>
    ),
  },
  {
    title: "Task",
    path: "/tasks",
    approved: false,

    icon: (
      <SvgIcon fontSize="small">
        <TaskAltOutlined />
      </SvgIcon>
    ),
  },
  {
    title: "Add Own Content",
    path: "/owncontent",
    approved: false,

    icon: (
      <SvgIcon fontSize="small">
        <Plus />
      </SvgIcon>
    ),
  },
  {
    title: "Payments",
    path: "/payments",
    approved: false,

    icon: (
      <SvgIcon fontSize="small">
        <ArchiveOutlined />
      </SvgIcon>
    ),
  },
  {
    title: "Settings",
    path: "/settings",
    approved: false,

    icon: (
      <SvgIcon fontSize="small">
        <Settings />
      </SvgIcon>
    ),
  },
];
